import type {Endpoints} from "@hosttools/web/server/routes/routes.billing.types";

import type {Billing, Frequency} from "../../models/billing";
import type {PricingPlan} from "../../models/listing";
import {Base} from "../base";

export class BillingService extends Base<Endpoints> {
    async fetchBilling(plan?: PricingPlan) {
        const {data} = await this.http.get<Billing>(
            `/getBilling${plan ? `?plan=${plan}` : ""}`,
            undefined
        );

        return data;
    }

    async updateFrequency(frequency: Billing["frequency"]) {
        const url = "/updateFrequency";
        const fields = {frequency};
        await this.http.post(url, fields);
    }

    async resubscribe() {
        const {data} = await this.http.post("/resubscribe");
        return data;
    }

    async cancelSubscription() {
        await this.http.post("/cancelSubscription");
    }

    async checkout(frequency: Frequency, plan?: PricingPlan) {
        const url = "/checkout";
        const fields = {frequency, plan};
        const {data} = await this.http.post<{url: string}>(url, fields);
        return data;
    }
}
